




























import Vue from 'vue'
import { Item2IconElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'Item2IconEl',

  props: {
    templateItemData: {
      type: Object as () => Item2IconElInterface,
      required: true
    }
  },

  computed: {
    separator (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'separator')) {
        return 'height: 0.05rem; background-color: black'
      }
      return `height: 0.05rem; background-color: ${this.$props.templateItemData.separator};`
    }
  }
})
